module.exports = __webpack_public_path__ + "static/scale-model-of-pittsburgh-pennsylvania-41310a7d7b6bbac570a6a530e5a9b643.png";